const API_URL = 'https://khulo.lumos.com.ge';

export const getYears = async () => {
	const response = await fetch(`${API_URL}/sakrebulo/years/`);
	const data = await response.json();
	return data.results;
};

export const getAngarishebi = async year => {
	const response = await fetch(
		`${API_URL}/sakrebulo/angarishebi/?year=${year}`
	);
	const data = await response.json();
	return data.results;
};

// get position
export const getPositions = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/position/`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

// get members by position
export const getMembersByPosition = async position => {
	try {
		const response = await fetch(
			`${API_URL}/sakrebulo/member/?position=${position}`
		);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

// get members by biuro

export const getMembersByBiuro = async biuro => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/member/?biuro=${biuro}`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};
// get members
export const getMembers = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/member/`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

// get members by slug
export const getMemberBySlug = async slug => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/member/${slug}`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

// get komisiebi
export const getKomisiebi = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/komisia/`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};
// get komisia by slug
export const getKomisiaBySlug = async slug => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/komisia/${slug}`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};
//get fraqciebi
export const getFraqciebi = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/fraqcia/`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};
// get fraqcia by slug
export const getFraqciaBySlug = async slug => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/fraqcia/${slug}`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};
// get budget
export const getBudget = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/budget/`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

// get pages
export const getPages = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/pages/`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

// get aparati
export const getAparatiSakrebulo = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/aparati/`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

//get actebi
export const getActebi = async (title, year) => {
	try {
		const response = await fetch(
			`${API_URL}/sakrebulo/acts/?category=${title}&year=${year}`
		);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

export const getActebiCategory = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/acts/category`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

// get sub_category
export const getSubCategory = async () => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/acts/category/sub_category`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};

//get sub_category slug
export const getSubCategorySlug = async (title,year) => {
	try {
		const response = await fetch(`${API_URL}/sakrebulo/acts/sub_acts?sub_category=${title}&year=${year}`);
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		return data.results;
	} catch (error) {
		console.error('There has been a problem with your fetch operation:', error);
		return null; // or handle the error as needed
	}
};
// export const getAngarishebiBySlug = async (slug) => {
//   const response = await fetch(`${API_URL}${slug}`);
//   const data = await response.json();
//   return data.results;
// };

// get video Gallery
export const getVideoGallery = async () => {
	const response = await fetch(`${API_URL}/news/video-gallery/`);
	const data = await response.json();
	return data.results;
};

export const getSocialMedia = async () => {
	const response = await fetch(`${API_URL}/news/social/`);
	const data = await response.json();
	return data.results;
};

//meria

export const getMeri = async () => {
	const response = await fetch(`${API_URL}/meria/mayor/`);
	const data = await response.json();
	return data.results;
}

export const getMoadgileebi = async () => {
	const response = await fetch(`${API_URL}/meria/deputy-mayors`);
	const data = await response.json();
	return data.results;
};

export const getMoadgilebiBySlug = async slug => {
	const response = await fetch(`${API_URL}/meria/deputy-mayors/${slug}`);
	const data = await response.json();
	return data;
};
export const getMeriisSamsakhurebi = async () => {
	const response = await fetch(`${API_URL}/meria/office-members/`);
	const data = await response.json();
	return data.results;
}
export const getMeriisSamsakhurebiBySlug = async slug => {
	const response = await fetch(`${API_URL}/meria/office-members/${slug}`);
	const data = await response.json();
	return data;
}

export const getStaticPageBySlug = async slug => {
	const response = await fetch(`${API_URL}/meria/static-pages/${slug}`);
	const data = await response.json();
	return data;
};
export const getCityCouncil = async () => {
	const response = await fetch(`${API_URL}/sakrebulo/city_council/`);
	const data = await response.json();
	return data.results;
}
export const getCityCouncilByYear = async year => {
	const response = await fetch(`${API_URL}/sakrebulo/member/?year=${year}`);
	const data = await response.json();
	return data;
}